module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00435.a22cdf21.jpg";